import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

// Async thunks
export const addShop = createAsyncThunk(
  "shop/add",
  async (data, { getState, rejectWithValue }) => {
    try {
      console.log(data);

      const axiosInstance = createAuthenticatedAxiosInstance();
      const response = await axiosInstance.post(baseUrl + "shops", data);
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        message: error.response?.data?.message || "Failed to add shop",
      });
    }
  }
);

export const getShops = createAsyncThunk(
  "shop/getAll",
  async (_, { getState, rejectWithValue }) => {
    try {
      const axiosInstance = createAuthenticatedAxiosInstance();
      const response = await axiosInstance.get(baseUrl + "shops");
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message || "Failed to fetch shops",
      });
    }
  }
);

export const updateShop = createAsyncThunk(
  "shop/update",
  async (data, { getState, rejectWithValue }) => {
    try {
      const axiosInstance = createAuthenticatedAxiosInstance();
      const response = await axiosInstance.put(
        `${baseUrl}shops/${data._id}`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message || "Failed to update shop",
      });
    }
  }
);

export const deleteShop = createAsyncThunk(
  "shop/delete",
  async (id, { getState, rejectWithValue }) => {
    try {
      const axiosInstance = createAuthenticatedAxiosInstance();
      const response = await axiosInstance.delete(`${baseUrl}shops/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message || "Failed to delete shop",
      });
    }
  }
);

const initialState = {
  shops: [],
  isLoading: false,
  error: null,
  success: false,
  message: "",
};

const shopSlice = createSlice({
  name: "shop",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Add shop
      .addCase(addShop.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addShop.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.message = action.payload?.message || "Shop added successfully";
        state.error = null;
        if (action.payload?.data) {
          state.shops.push(action.payload.data);
        }
      })
      .addCase(addShop.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || { message: "Failed to add shop" };
      })
      // Get shops
      .addCase(getShops.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getShops.fulfilled, (state, action) => {
        state.isLoading = false;
        state.shops = action.payload?.data || [];
        state.error = null;
      })
      .addCase(getShops.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || { message: "Failed to fetch shops" };
      })
      // Update shop
      .addCase(updateShop.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateShop.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.message = action.payload?.message || "Shop updated successfully";
        state.error = null;
        if (action.payload?.data) {
          const index = state.shops.findIndex(
            (shop) => shop._id === action.payload.data._id
          );
          if (index !== -1) {
            state.shops[index] = action.payload.data;
          }
        }
      })
      .addCase(updateShop.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || { message: "Failed to update shop" };
      })
      // Delete shop
      .addCase(deleteShop.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteShop.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.message = action.payload?.message || "Shop deleted successfully";
        state.error = null;
      })
      .addCase(deleteShop.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || { message: "Failed to delete shop" };
      });
  },
});

export const { reset } = shopSlice.actions;
export default shopSlice.reducer;
